var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "app-footer max-w-full overflow-x-hidden"
  }, [_c('div', {
    staticClass: "bg-gray-150 shadow-inner"
  }, [_c('container', [_c('app-sponsors')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-white pt-32"
  }, [_c('container', [_c('row', _vm._l(_vm.items, function (itemGroup, itemsKey) {
    return _c('column', {
      key: itemsKey,
      attrs: {
        "cols": 6,
        "sm": 12 / _vm.items.length
      }
    }, [_c('nav-list', [_c('nav-list-header', {
      staticClass: "pl-16",
      attrs: {
        "x-small": ""
      }
    }, [_vm._v(_vm._s(itemGroup.title))]), _vm._v(" "), _vm._l(itemGroup.items, function (item, i) {
      return _c('nav-list-item', {
        key: i,
        staticClass: "mb-4",
        attrs: {
          "active-color": "primary",
          "small": "",
          "rounded-large": "",
          "to": item.href ? item.href : item.to,
          "exact": item.exact,
          "text": item.text
        }
      });
    })], 2)], 1);
  }), 1), _vm._v(" "), _c('divider'), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column-reverse sm:flex-row items-center justify-between w-full mt-24",
    class: _vm.withoutBottomPadding ? 'mb-24' : 'mb-64'
  }, [_c('p', {
    staticClass: "sm:none text-center text-xs mb-0"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + " SPOFERAN")]), _vm._v(" "), _c('social-icons', {
    staticClass: "md:w-300 mb-16 sm:mb-0",
    attrs: {
      "social-media": _vm.$config.socialMedia
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "none sm:block text-center text-xs mb-0"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + " SPOFERAN")]), _vm._v(" "), !_vm.$device.isNative ? _c('div', {
    staticClass: "md:w-300 mb-16 sm:mb-0"
  }, [_c('app-feature-buttons')], 1) : _vm._e()], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }